import { makeAsyncAction } from '../../../ui-lottery';
import * as types from '../constants/actions';
import * as api from '../api';

export const fetchActivities = makeAsyncAction(
    types.FETCH_ACTIVITIES,
    query => () => api.fetchActivities(query),
    'data'
);
